import { render, staticRenderFns } from "./DX.vue?vue&type=template&id=2e33e2ce&scoped=true&"
import script from "./DX.vue?vue&type=script&lang=js&"
export * from "./DX.vue?vue&type=script&lang=js&"
import style0 from "./DX.vue?vue&type=style&index=0&id=2e33e2ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e33e2ce",
  null
  
)

component.options.__file = "DX.vue"
export default component.exports